<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 设备状态分析
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="dataPicker">
                <el-date-picker
                    v-model="value2"
                    type="daterange"
                    align="center"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                ></el-date-picker>
                <el-button type="success" class="btn1">搜索</el-button>
                <el-button type="primary">刷新</el-button>
            </div>
            <div class="lineS" ref="deviceStatusLine"></div>
            <div class="botCharts">
                <div class="leftS" ref="deviceStatusPie"></div>
                <div class="rightS" ref="deviceStatusCat"></div>
            </div>

            <el-button type="primary">导出表格</el-button>

            <el-table class="elTable" :data="tableData" border style="width: 100%">
                <el-table-column prop="date" label="日期" align="center"></el-table-column>
                <el-table-column prop="s1" label="正常" align="center"></el-table-column>
                <el-table-column prop="s2" label="故障" align="center"></el-table-column>
                <el-table-column prop="s3" label="报警" align="center"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
// import { fetchData } from '../../api/index';
import * as echarts from 'echarts';
export default {
    data() {
        return {
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            value1: '',
            value2: '',
            tableData: [
                {
                    date: '2022-08-22',
                    s1: 11,
                    s2: 2,
                    s3: 0,
                },
                {
                    date: '2022-08-23',
                    s1: 12,
                    s2: 0,
                    s3: 1,
                },
                {
                    date: '2022-08-24',
                    s1: 13,
                    s2: 0,
                    s3: 0,
                },
                {
                    date: '2022-08-25',
                    s1: 13,
                    s2: 0,
                    s3: 0,
                },
                {
                    date: '2022-08-26',
                    s1: 13,
                    s2: 0,
                    s3: 0,
                },
                {
                    date: '2022-08-27',
                    s1: 12,
                    s2: 0,
                    s3: 1,
                },
                {
                    date: '2022-08-28',
                    s1: 13,
                    s2: 0,
                    s3: 0,
                }
            ]
        };
    },
    mounted() {
        setTimeout(() => {
            // 绘制设备状态折线图
            let myChart = this.$echarts.init(this.$refs.deviceStatusLine);
            myChart.setOption({
                color: ['#08d97b', '#ff8115', '#e83c03'],
                title: {
                    text: '设备状态分析曲线图'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                legend: {
                    data: ['正常', '故障', '报警']
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: ['8-9', '8-10', '8-11', '8-12', '8-13', '8-14', '8-15']
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '正常',
                        type: 'line',
                        stack: 'Total',
                        smooth: true,
                        lineStyle: {
                            width: 0
                        },
                        showSymbol: false,
                        areaStyle: {
                            opacity: 0.8,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: '#08d97b'
                                },
                                {
                                    offset: 1,
                                    color: '#08d97b'
                                }
                            ])
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: [11, 12, 13, 13, 13, 12, 13]
                    },
                    {
                        name: '故障',
                        type: 'line',
                        stack: 'Total',
                        smooth: true,
                        lineStyle: {
                            width: 0
                        },
                        showSymbol: false,
                        areaStyle: {
                            opacity: 0.8,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: '#ff8115'
                                },
                                {
                                    offset: 1,
                                    color: '#ff8115'
                                }
                            ])
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: [2, 0, 0, 0, 0, 0, 0]
                    },
                    {
                        name: '报警',
                        type: 'line',
                        stack: 'Total',
                        smooth: true,
                        lineStyle: {
                            width: 0
                        },
                        showSymbol: false,
                        areaStyle: {
                            opacity: 0.8,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: '#e83c03'
                                },
                                {
                                    offset: 1,
                                    color: '#d83c03'
                                }
                            ])
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: [0, 1, 0, 0, 0, 1, 0]
                    },
                ]
            });

            // 绘制设备状态饼状图
            let pieChart = this.$echarts.init(this.$refs.deviceStatusPie);
            pieChart.setOption({
                grid: {
                    bottom: 25
                },
                title: {
                    text: '设备状态分析饼状图',
                    left: 'left',
                    textStyle: {
                        color: '#000000'
                    }
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    left: 'bottom',
                    textStyle: {
                        color: '#000000'
                    }
                },
                series: [
                    {
                        name: '设备状态数量',
                        type: 'pie',
                        radius: '50%',
                        data: this.statusComputer(),
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            });

            // 绘制设备状态柱状图
            let catChart = this.$echarts.init(this.$refs.deviceStatusCat);
            catChart.setOption({
                 toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                title: {
                    text: '设备状态分析柱状图',
                    textStyle: {
                        color: '#000000'
                    }
                },
                grid: {
                    bottom: 25
                },
                tooltip: {},
                legend: {
                     textStyle: {
                        color: '#000000'
                    }
                },
                xAxis: {
                    data: this.beforDeviceDataComputerBar().xData
                },
                yAxis: {},
                series: this.beforDeviceDataComputerBar().vSeries
            });
        }, 10);
    },
    created() {},
    methods: {
          // 每日设备状态柱状图数据处理
        beforDeviceDataComputerBar() {
            let arr = this.$store.state.deviceBefore;
            let xData = arr.map(item => {
                return item.date;
            });
            let vSeries = [];
            let normalDataArr = [];
            let alarmDataArr = [];
            let trouleDataArr = [];
            this.$store.state.deviceBefore.forEach(item => {
                normalDataArr.push(item.normal);
                alarmDataArr.push(item.alarm);
                trouleDataArr.push(item.troule);
            });
            vSeries.push({
                name: '正常',
                type: 'bar',
                itemStyle: {
                    color: '#08d97b'
                },
                data: normalDataArr
            });

            vSeries.push({
                name: '报警',
                type: 'bar',
                itemStyle: {
                    color: '#e83c03'
                },
                data: alarmDataArr
            });
            vSeries.push({
                name: '故障',
                type: 'bar',
                itemStyle: {
                    color: '#ff8115'
                },
                data: trouleDataArr
            });
            return {
                xData,
                vSeries
            };
        },

         // 统计设备状态数据处理
        statusComputer() {
            let arr = [];
            arr = this.$store.state.deviceNowData.map((item) => {
                return item.status;
            });

            let obj = {};
            for (let i = 0; i < arr.length; i++) {
                var item = arr[i];
                obj[item] = obj[item] + 1 || 1;
            }
            let computerData = [];
            for (const key in obj) {
                switch (key) {
                    case '正常':
                        computerData.push({
                            name: key,
                            value: obj[key],
                            itemStyle: {
                                color: '#08d97b'
                            }
                        });
                        break;
                    case '故障':
                        computerData.push({
                            name: key,
                            value: obj[key],
                            itemStyle: {
                                color: '#ff8115'
                            }
                        });
                        break;
                    case '报警':
                        computerData.push({
                            name: key,
                            value: obj[key],
                            itemStyle: {
                                color: '#e83c03'
                            }
                        });
                        break;

                    default:
                        break;
                }
            }
            return computerData;
        },
    }
};
</script>

<style lang="less" scoped>
.lineS {
    width: 100%;
    height: 300px;
}
.botCharts {
    margin-top: 20px;
    width: 100%;
    height: 400px;
    display: flex;
}
.leftS {
    width: 40%;
    height: 400px;
}
.rightS {
    width: 60%;
    height: 400px;
}
.dataPicker {
    display: flex;
    font-size: 0.5rem;
    align-items: center;
    height: 1rem;
    .btn1 {
        margin-left: 20px;
    }
}
.elTable {
    margin-top: 20px;
}
</style>


